import { DecisionServiceVersionBusinessData } from "./DecisionServiceVersionBusinessData"/* tslint:disable */




import { DecisionServiceVersionPairData } from "./DecisionServiceVersionPairData"
import { DecisionServiceVersionListData } from "./DecisionServiceVersionListData"

export class DecisionServiceVersionDescription {
		DecisionServiceId: number;
		Name: string;
		DecisionName: string;
		DecisionServiceVersionId: number;
		VersionNumber: number;

		InputData: DecisionServiceVersionBusinessData[];
		OutputData: DecisionServiceVersionBusinessData[];
		TraceData: DecisionServiceVersionBusinessData[];
		MetaData: DecisionServiceVersionBusinessData[];
		PairData: DecisionServiceVersionPairData[];
		ListData: DecisionServiceVersionListData[];
}




// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/DecisionServiceVersionDescription.ts